module.exports = __webpack_public_path__ + "static/img/login_column_two02.cc49a4fa.png";